<template>
  <div
    class="snackbar-container ma-3"
    @mouseenter="onMouseIn()"
    @mouseleave="onMouseOut()"
  >
    <!-- <v-snackbar v-bind="$attrs" v-on="$listeners" :color="data.color || 'error'">
    {{data.message || data.errorMessage}}
    <v-btn
      icon
      plain
      left
      @click="closeMessage"
    >
      <v-icon>
        mdi-close
      </v-icon>
    </v-btn>
  </v-snackbar> -->
    <v-alert
      style="margin-bottom : 0px; "
      border="left"
      :type="data.color || 'error'"
      colored-border
      tile
    >
      <template #default>
        {{ data.message || data.errorMessage }}
      </template>
      <template #append>
        <v-btn
          icon
          @click.once="closeSnackBar"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-alert>
    <v-progress-linear
      v-model="value"
      :color="typeColor()"
      :indeterminate="false"
      :query="true"
      dark
      height="4"
    ></v-progress-linear>
  </div>
</template>

<script>
export default {
  name: "AppSnackBar",
  props: ["snackBar", "show","data"],
  data () {
    return {
      value: 0,
      interval: 0,
    }
  },
  mounted(){
    this.queryAndIndeterminate();
  },
  methods: {
    queryAndIndeterminate () {
      this.value = 0
      this.interval = setInterval(() => {
        if (this.value === 100) {
          this.closeSnackBar()
        }
        this.value += 4
      }, 140)
    },
    closeSnackBar(){
      clearInterval(this.interval);
      this.snackBar.close();
      },
    typeColor(){
      switch(this.data.color){
        case "error":
          return "#ff5252"
        case "info" :
          return "#2969E3"
        case "success":
          return "#4CAF50"
        default :
          return "#ff5252"
      }
    },
    onMouseIn(){
      clearInterval(this.interval);
    },
    onMouseOut(){
      this.queryAndIndeterminate();
    }
  }
};
</script>

<style>
.snackbar-container{
  z-index : 90000; 
  bottom : 0; 
  right:0; 
  position:fixed;
  box-shadow: 1px 1px 2px 2px rgba(12, 12, 25, .5);
}
.v-alert__icon{
  align-self: center;
}
</style>